import * as CL from '@design-system/component-library';
import * as React from 'react';
import { dsClass } from '../../common/constants/dsClasses';
import { removeMsg, t } from '../../common/i18n/index.js';
import { FilterType } from '../ProductGrid/ProductGridFilter';

import './FilterTag.scss';

interface FilterTagProps {
  subcategory: string;
  label: string;
  onRemoveFilter: () => void;
}

export const FilterTag: React.FC<FilterTagProps> = ({ subcategory, label, onRemoveFilter }) => {
  return (
    <div key={subcategory + label} className="of-filter-tag">
      {label}
      {subcategory === FilterType.FILTER_COST ? ' €' : ''}
      <button
        aria-label={`${t.R3VE(removeMsg)} ${label}`}
        className="of-filter-tag__filter-close-button"
        onClick={onRemoveFilter}
        type="button"
      >
        <CL.Icon
          aria-hidden="true"
          className={`${dsClass.PADDING_LEFT_1} of-filter-tag__filter-close-icon`}
          icon="close"
          size="s"
          type="regular"
          color="black"
        />
      </button>
    </div>
  );
};
